// Return if str is only NULL, undefined or empty string
export function isStringEmptyOrWhitespace(str: string | null | undefined): boolean {
    if (str === undefined) return true;
    if (str === null) return true;
    if (str.trim().length === 0) return true;

    return false;
}
